import React, { useContext } from 'react'
import { useSelector } from 'react-redux'
import { HIDE_FLASH_BANNER } from '@consts/index'
import { useRouter } from 'next/router'

import styles from './styles.module.scss'
import { RootState } from '@store/redux/reducers'
import { NotificationBannerState } from '@store/redux/reducers/otherReducers'
import PromoBanner from './PromoBanner'
import AppContext from '@components/AppContext'
import PushNotificationBanner from './PushNotificationBanner'

const FlashBanner = () => {
  const router = useRouter()
  const { flashBanner } = useContext(AppContext)
  const { showBanner, ...banner } = flashBanner || {}

  const notificationBanner = useSelector<RootState, NotificationBannerState>(
    state => state.notificationBanner
  )
  const isDynamicFlashBannerVisible =
    Object.keys(banner).length > 0 &&
    showBanner &&
    !HIDE_FLASH_BANNER.includes(router.query.pagesHandle?.toString?.() ?? '')

  return (
    <>
      <PushNotificationBanner {...notificationBanner} />
      {isDynamicFlashBannerVisible && (
        <section data-testid="DynamicFlashBanner" className={styles.flash}>
          <PromoBanner {...banner} />
        </section>
      )}
    </>
  )
}

export default FlashBanner
